'use strict';
/**
 * @author Batch Themes Ltd.
 */
(function() {
    $(function() {

        var config = {
            name: 'Peak',
            colors: ['#003e52']
        };
        if ($('html').hasClass('loading')) {
            var loaderTime = 100;
            var loaderColor = config.colors[0];

            $("#fakeloader").fakeLoader({
                timeToHide: loaderTime,
                zIndex: "99999", //Default zIndex
                spinner: "spinner1", //Options: 'spinner1', 'spinner2', 'spinner3', 'spinner4', 'spinner5', 'spinner6', 'spinner7'
                bgColor: loaderColor,
                imagePath: "/img/keepers-loader.gif",
            });
            setTimeout(function() {
                $('html').removeClass('loading');
            }, loaderTime);
        }
        $('body').bootstrapMaterialDesign({
            text: {
                selector: [`input:not([type=range]):not([type=hidden]):not([type=checkbox]):not([type=radio]):not([type=file]):not([type=button]):not([type=submit]):not([type=reset])`],
            },
        });

        Mousetrap.bind('ctrl+2', function() {
            var layout = $('body').data('layout');
            $('body').toggleClass('layout-collapsed');
            if (layout === 'default-sidebar-2' && $('body').hasClass('layout-collapsed')) {
                $('.left-sidebar-backdrop').toggleClass('fade in');
            } else if (layout === 'top-navigation-1' && $('body').hasClass('layout-collapsed')) {
                $('.left-sidebar-backdrop').toggleClass('fade in');
            } else if (layout === 'top-navigation-2' && $('body').hasClass('layout-collapsed')) {
                $('.left-sidebar-backdrop').toggleClass('fade in');
            } else if (layout === 'fixed-navbar-1' && $('body').hasClass('layout-collapsed')) {
                $('.left-sidebar-backdrop').toggleClass('fade in');
            } else {
                $('.left-sidebar-backdrop').removeClass('fade');
                $('.left-sidebar-backdrop').removeClass('in');
            }
        });
        Mousetrap.bind('ctrl+4', function() {
            $(document).fullScreen(true);
        });
        Mousetrap.bind('ctrl+5', function() {
            $('.top-search').toggleClass('show-from-top');
        });

        $('#pjax-container').show();

        $('div.dataTables_filter input').addClass('form-control');
        $('div.dataTables_length label select').addClass('form-control');
    });
})();
